export interface InflowInfiltrationMetricRow {
	id: string;
	label: string;
	value: number;
	unit: string;
	format: string;
	description?: string;
	tooltip?: string;
}

export interface InflowInfiltrationMetrics {
	assetId: string;
	locationId: number;
	locationName: string;
	assetName: string;
	assetTypeId: number;
	assetTypeName: string;
	organizationId: string;
	organizationName: string;
	modeType: 'depth' | 'flow';
	rows: InflowInfiltrationMetricRow[];
}

export const DASHBOARD_MODE = {
	INFILTRATION_FLOW: 'infiltration_flow',
	INFILTRATION_DEPTH: 'infiltration_depth',
	METRICS_FLOW: 'flow',
	METRICS_DEPTH: 'depth',
	PAST_OVERFLOW: 'past_overflow_mode'
}

export interface PastOverflowMetrics {
	baseline: string;
	actual: string;
	difference: string;
	differencePercent: string;
	totalDepth: string;
	peakHourlyIntensity: string;
}